import type { ForecastRun } from '../types'
import './RunMetadataPanel.css'

function fmtDateTime(iso?: string | null): string {
  if (!iso) return '--'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '--'
  return d.toLocaleString()
}

function fmtDuration(ms?: number): string {
  if (!ms && ms !== 0) return '--'
  const totalSec = Math.round(ms / 1000)
  const m = Math.floor(totalSec / 60)
  const s = totalSec % 60
  return `${m}m ${String(s).padStart(2, '0')}s`
}

function fmtNum(n?: number): string {
  if (n == null || Number.isNaN(n)) return '--'
  return n.toLocaleString()
}

export default function RunMetadataPanel({ run }: { run?: ForecastRun | null }) {
  if (!run) return null

  const models = run.config?.models || {}
  const numAgents = run.config?.num_agents
  const tokens = run.token_summary || {}
  const isComplete = run.status === 'complete'

  return (
    <div className="run-metadata">
      <div className="run-metadata-title">Run metadata</div>
      <div className="run-metadata-grid">
        <div className="run-meta-item">
          <div className="run-meta-label">Duration</div>
          <div className="run-meta-value">
            {isComplete ? fmtDuration(run.total_duration_ms) : 'Running…'}
          </div>
        </div>
        <div className="run-meta-item">
          <div className="run-meta-label">Started at</div>
          <div className="run-meta-value">{fmtDateTime(run.created_at)}</div>
        </div>
        <div className="run-meta-item">
          <div className="run-meta-label">Completed at</div>
          <div className="run-meta-value">{fmtDateTime(run.completed_at)}</div>
        </div>
        <div className="run-meta-item">
          <div className="run-meta-label">Agents</div>
          <div className="run-meta-value">{numAgents ?? '--'}</div>
        </div>
        <div className="run-meta-item">
          <div className="run-meta-label">Tokens (in/out)</div>
          <div className="run-meta-value">
            {fmtNum(tokens.total_in)} / {fmtNum(tokens.total_out)}
          </div>
        </div>
        <div className="run-meta-item">
          <div className="run-meta-label">Cached input</div>
          <div className="run-meta-value">{fmtNum(tokens.total_cached_in)}</div>
        </div>
        <div className="run-meta-item">
          <div className="run-meta-label">Predictor model</div>
          <div className="run-meta-value">{models.predictor || run.config?.predictor_model || '--'}</div>
        </div>
        <div className="run-meta-item">
          <div className="run-meta-label">Supervisor model</div>
          <div className="run-meta-value">{models.supervisor || run.config?.supervisor_model || '--'}</div>
        </div>
      </div>
    </div>
  )
}


